<template>
  <div class="leea-card">
    <div class="leea-card-title">
      <slot name="title"></slot>
    </div>
    <div class="leea-card-description">
      <slot name="description"></slot>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<style lang="scss" scoped>
.leea-card {
  background-color: var(--black-color);
  width: 100%;
  border-radius: 25px;
  padding: 25px;
  box-sizing: border-box;
  color: white;
  .leea-card-title {
    font-family: 'Forma DJR Display';
    font-weight: 500;
    font-size: 30px;
    letter-spacing: 0.04em;
    margin-bottom: 8px;
  }
  .leea-card-description {
    margin-bottom: 25px;
    opacity: 0.8;
  }
}
</style>
